import {
  LOADING_MET,
  GET_MET_SUCCESS,
  GET_MET_FAILURE,
  SET_MET_SEARCH_QUERY,
  SET_MET_PAGE,
  GET_MET_INFO_SUCCESS,
  GET_MET_INFO_FAILURE
} from "../actions/types/medicalEntityTypes";

const initialState = {
  types: [],
  medicalEntity: {},
  loading: false,
  links: {
    first: null,
    last: null,
    next: null,
    prev: null
  },
  meta: {
    from: null,
    to: null,
    total: null
  },
  filters: {
    page: 1,
    query: ""
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MET: {
      return {
        ...state,
        loading: true
      };
    }

    case GET_MET_SUCCESS: {
      return {
        ...state,
        types: action.payload.types,
        loading: false,
        links: {
          ...state.links,
          first: action.payload.links.first,
          last: action.payload.links.last,
          next: action.payload.links.next,
          prev: action.payload.links.prev
        },
        meta: {
          ...state.meta,
          from: action.payload.meta.from,
          to: action.payload.meta.to,
          total: action.payload.meta.total
        }
      };
    }

    case GET_MET_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case SET_MET_SEARCH_QUERY: {
      return {
        ...state,
        filters: {
          ...state.filters,
          query: action.payload.value,
          page: 1
        }
      };
    }

    case SET_MET_PAGE: {
      return {
        ...state,
        filters: {
          ...state.filters,
          page: action.payload.value
        }
      };
    }

    case GET_MET_INFO_SUCCESS: {
      return {
        ...state,
        medicalEntity: {
          ...state.medicalEntity,
          ...action.payload.medicalEntity
        },
        loading: false
      };
    }

    case GET_MET_INFO_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    default: {
      return state;
    }
  }
};
